export const randomInt = () => {
  // get a random int betwenn 0 and 999
  return Math.floor(Math.random() * 1000);
};
